import { useId } from "react";

import cn from "classnames";

import { Button } from "@/components/button/button.component";
import { InfoIcon } from "@/components/icons/info.icon";
import { TooltipArrowIcon } from "@/components/icons/tooltipArrow.icon";
import { Text } from "@/components/text/text.component";

export const Tooltip = ({
  label,
  text,
  placement = "default",
}: TooltipProps) => {
  const id = useId();
  const popoverUUID = `info-tooltip-${id}`;
  const learnMoreUUID = `info-tooltip-learn-more-${id}`;
  const anchorName = `--info-tooltip-anchor-${id.replaceAll(":", "")}`;
  const isCompareRowPlacement = placement === "compare-row";

  return (
    <>
      <div
        role="tooltip"
        id={popoverUUID}
        popover="auto"
        className={cn(
          "bg-greyscale-background m-0 overflow-visible rounded-lg p-5 shadow-(--shadow-soft-blue)",
          {
            "fixed top-[calc(anchor(bottom)+8px)] right-4 left-4 z-30 max-w-none lg:top-[calc(anchor(bottom)+12px)] lg:right-auto lg:left-[calc(anchor(left)-136px)] lg:max-w-72":
              isCompareRowPlacement,
            "relative max-w-48 lg:max-w-72": !isCompareRowPlacement,
          },
        )}
        style={{
          positionAnchor: anchorName,
          ...(isCompareRowPlacement
            ? {}
            : {
                top: "calc(anchor(bottom) + 12px)",
                left: "calc(anchor(left) - 136px)",
              }),
        }}>
        <Text component="p" variant="body3">
          {text}
        </Text>
        <TooltipArrowIcon
          width={24}
          height={16}
          className="absolute top-0 left-1/2 z-10 -translate-x-1/2 -translate-y-full"
          aria-hidden
        />
      </div>
      {text ? (
        <Button
          id={learnMoreUUID}
          type="button"
          aria-label={`More info about ${label}`}
          data-testid="compare-row-info-icon"
          className={cn("cursor-pointer align-middle", {
            "ml-1 inline-flex min-h-6 min-w-6 items-center justify-center max-lg:[interest-delay-start:100000s] lg:ml-0":
              isCompareRowPlacement,
            "ml-1 inline-flex min-h-6 min-w-6 items-center justify-center max-lg:[interest-delay-start:100000s]":
              !isCompareRowPlacement,
          })}
          popoverTarget={popoverUUID}
          interestfor={popoverUUID}
          style={{ anchorName }}>
          <InfoIcon width={16} height={16} className="stroke-secondary" />
        </Button>
      ) : null}
    </>
  );
};

type TooltipProps = {
  label: string;
  text: string;
  placement?: "default" | "compare-row";
};
